import { useEffect, useState } from 'react';
import { toast } from '../../../../core/components/atoms/Toast';
import { deckService } from '../../queries';
import useUserMemory from '../use-user-memory';

const useDecksAvailable = () => {
  const { memoryUserUuid } = useUserMemory();
  const userUuid = memoryUserUuid;

  const [decksAvailable, setDecksAvailable] = useState<{
    hasAvailableFlashcards: boolean;
    decks: {
      totalReviewNow: number;
      deckUuid: string;
      title: string;
      totalFlashcards: number;
      totalFlashcardsNew: number;
      totalFlashcardsReviewed: number;
    }[];
  }>({
    hasAvailableFlashcards: false,
    decks: [],
  });
  const [isLoading, setIsLoading] = useState(false);

  const fetchAvailableFlashcards = async () => {
    if (!userUuid) return;
    try {
      setIsLoading(true);
      const decksAvailable = await deckService.checkAvailableFlashcardsToReview(
        { userUuid, returnUuidDecks: true }
      );
      setDecksAvailable(decksAvailable);
    } catch (error) {
      console.error(error);
      toast({
        title: 'Erro ao buscar flashcards disponíveis',
        message: 'Tente novamente mais tarde',
        variant: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAvailableFlashcards();
  }, [userUuid]);

  return {
    decksAvailable,
    fetchAvailableFlashcards,
    isLoadingDecksAvailable: isLoading,
  };
};

export default useDecksAvailable;
